// src/pages/admin/EditStorehouse.js
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import {Box} from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import TextField from "@mui/material/TextField";
import { Button as MuiButton } from '@mui/material';
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";

export default function EditStorehouse() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [storehouse, setStorehouse] = useState({ code: "", name: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchStorehouse() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BASE_URL}common/storehouses/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setStorehouse({ code: data.code, name: data.name });
      } catch (error) {
        console.error("Error fetching storehouse:", error);
        alert("Could not load storehouse.");
      } finally {
        setLoading(false);
      }
    }
    fetchStorehouse();
  }, [id]);

  const updateStorehouse = async () => {
    const { code, name } = storehouse;
    if (!code) {
      alert("Storehouse code cannot be empty.");
      return;
    }

    try {
      await axios.put(
        `${process.env.REACT_APP_BASE_URL}common/storehouses/${id}`,
        storehouse,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      alert("Storehouse updated successfully!");
      navigate("/storehouse-list");
    } catch (error) {
      console.error("Error updating storehouse:", error);
      alert(
        error.response?.data?.message ||
          "Error updating storehouse. Please try again."
      );
    }
  };

  if (loading)
    return (
      <PageLayout>
        <p>Loading…</p>
      </PageLayout>
    );

  return (
    <PageLayout>
      <Grid container spacing={2} className="align-items-center">
        <Grid size={{ xs: 12, md: 6 }}>
          <Breadcrumb title="Edit Storehouse" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} className="text-end">
          <Link to="/storehouse-list">
            <MuiButton variant="contained" color="secondary">Back to List</MuiButton>
          </Link>
        </Grid>
      </Grid>

      <Grid container spacing={2} className="mt-4">
        <Grid size={{ xs: 12 }}>
          <Box className="mc-card">
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }} className="mb-3">
                <CardHeader title="Storehouse Code" />
                <TextField
                  fullWidth
                  value={storehouse.code}
                  onChange={(e) =>
                    setStorehouse({ ...storehouse, code: e.target.value })
                  }
                />
              </Grid>

              <Grid size={{ xs: 12 }} className="mb-3">
                <CardHeader title="Storehouse Name" />
                <TextField
                  fullWidth
                  placeholder="Optional human-readable name"
                  value={storehouse.name}
                  onChange={(e) =>
                    setStorehouse({ ...storehouse, name: e.target.value })
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid size={{ xs: 12 }} className="mt-3 d-flex justify-content-end">
          <MuiButton variant="contained" color="primary" onClick={updateStorehouse}>
            Save Changes
          </MuiButton>
        </Grid>
      </Grid>
    </PageLayout>
  );
}
